import { render, staticRenderFns } from "./VaccinationPerCompanyPanel.vue?vue&type=template&id=16ebdb6b&scoped=true&"
import script from "./VaccinationPerCompanyPanel.vue?vue&type=script&lang=js&"
export * from "./VaccinationPerCompanyPanel.vue?vue&type=script&lang=js&"
import style0 from "./VaccinationPerCompanyPanel.vue?vue&type=style&index=0&id=16ebdb6b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16ebdb6b",
  null
  
)

export default component.exports